// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"b83ef8ca","532":"b83ef8ca"}[chunkId] + ".chunk.css";
};